var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'layout__auth',
    {
      'layout__auth--has-footer': _vm.footerIsVisible
    }
  ]},[_c('div',{staticClass:"layout__auth__grid"},[(_vm.sidebarIsVisible)?_c('LayoutAuthSidebar'):_vm._e(),_c('LayoutAuthContent',[_vm._t("default")],2)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }